import type { TodoItem } from "@/modules/chat/types";
import type { SidePanelProps } from "../../layout/sidePanels";

/**
 * Progress panel — renders `state.plan` as a collapsible task list.
 * Mounted by the SIDE_PANELS registry (see layout/sidePanels.ts).
 *
 * This component renders only the inner <details className="details-section">
 * — the outer `.details-card` wrapper and "Детали" header are owned by
 * SideStack. Stays always visible as a UX anchor; shows a placeholder when
 * no plan exists yet.
 */
export function TodoPanel({ value }: SidePanelProps) {
  const todos = (Array.isArray(value) ? value : []) as TodoItem[];

  const completed = todos.filter((t) => t.status === 'completed').length;
  const total = todos.filter((t) => t.status !== 'cancelled').length;
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <details className="details-section" open>
      <summary className="details-section-header">
        <span>Прогресс</span>
        {total > 0 && <span className="details-progress-badge">{pct}%</span>}
      </summary>
      <div className="details-section-body">
        {todos.length === 0 ? (
          <div className="details-empty">
            Задачи появятся, когда агент составит план
          </div>
        ) : (
          <div className="todo-list">
            {todos.map((todo, i) => {
              const isLast = i === todos.length - 1;
              const nextDone = !isLast && todos[i + 1]?.status === 'completed';
              return (
                <label key={i} className={`todo-item todo-${todo.status}`}>
                  <div className="todo-track">
                    <input
                      type="checkbox"
                      checked={todo.status === 'completed'}
                      readOnly
                    />
                    {!isLast && (
                      <div
                        className={`todo-connector${
                          todo.status === 'completed' && nextDone ? ' todo-connector-done' : ''
                        }`}
                      />
                    )}
                  </div>
                  <span className="todo-content">{todo.content}</span>
                </label>
              );
            })}
          </div>
        )}
      </div>
    </details>
  );
}
